module.exports = __webpack_public_path__ + "img/pin-icon.50f49983.svg";